import { createRouter, createWebHistory } from "vue-router";
import Produtos from "../views/produtos.vue";

const routes = [
    {
        path: "/",
        component: () => import("@/views/home.vue"),
    },
    {
        path: "/sobre-nos",
        component: () => import("@/views/sobre-nos.vue"),
    },
    {
        path: "/produtos/:categoriaSlug",
        name: "produtos-categoria",
        component: Produtos,
    },
    {
        path: "/produtos/:categoriaSlug/:subcategoriaSlug",
        name: "produtos-subcategoria",
        component: Produtos,
    },
    {
        path: "/produto/:slug",
        name: "produto",
        component: () => import("@/views/produto.vue"),
    },
    {
        path: "/produto/:slug/:tamanhoSlug",
        name: "produto-tamanho",
        component: () => import("@/views/produto.vue"),
    },
    {
        path: "/blog",
        name: "blog",
        component: () => import("@/views/blog.vue"),
    },
    {
        path: "/blog/artigo/:slug",
        name: "blog-post",
        component: () => import("@/views/blog-post.vue"),
    },
    {
        path: "/vagas",
        name: "vagas",
        component: () => import("@/views/vagas.vue"),
    },
    {
        path: "/vaga/:slug",
        name: "vaga-detalhes",
        component: () => import("@/views/vaga-detalhes.vue"),
    },
    {
        path: "/vaga/candidatar/:slug",
        name: "vaga-candidatar",
        component: () => import("@/views/vaga-form.vue"),
    },
    {
        path: "/contato",
        name: "contato",
        component: () => import("@/views/contato.vue"),
    },
    {
        path: "/politica-de-privacidade",
        name: "politica-de-privacidade",
        component: () => import("@/views/politica-de-privacidade.vue"),
    },
    {
        path: "/termos-de-uso",
        name: "termos-de-uso",
        component: () => import("@/views/termos-de-uso.vue"),
    },
    {
        path: "/downloads",
        name: "downloads",
        component: () => import("@/views/downloads.vue"),
    },
    {
        path: "/simulador-ambiente",
        name: "simulador-ambiente",
        component: () => import("@/views/simulador-ambiente.vue"),
    },
    {
        path: "/simulador-rejunte",
        name: "simulador-rejunte",
        component: () => import("@/views/simulador-rejunte.vue"),
    },
    {
        path: "/:pathMatch(.*)*",
        name: "NotFound",
        component: () => import("@/views/404.vue"),
    },
    {
        path: "/calculadora-consumo",
        name: "calculadora-consumo",
        component: () => import("@/views/calculadora-consumo.vue"),
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }
});

export default router;
